import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Section } from 'UIPackage/FormModule/components/Section';
import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';
import { KnmHistoryItem } from 'KnmPackage/KnmHistoriesModule/components/KnmHistoryItem';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmDataPlanId } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { getPlanHistoryChanges } from 'PlanPackage/MainModule/selectors/planSelectors';
import { KNM_PLAN_HISTORY_CHANGES } from 'CorePackage/MainModule/routes/routes';

import styles from './ErknmPlanHistory.module.scss';

const PAGE_SIZE = 10;

interface IKnmHistoryStoreProps {
  planId?: number | null;
  historyChanges?: IKnmHistoryItemChanges[];
}

const ErknmPlanHistoryChangesWithoutStore = ({ planId, historyChanges }: IKnmHistoryStoreProps) => {
  const [itemsPage, setItemsPage] = useState<number>(0);
  const handleLoadMoreButtonClick = useCallback(() => setItemsPage(prev => prev + 1), []);

  if (!planId) {
    return null;
  }

  const lastVisibleItemsNumber = (itemsPage + 1) * PAGE_SIZE;
  const isLoadMoreButtonVisible = historyChanges && historyChanges.length > lastVisibleItemsNumber;

  return (
    <Section title="История изменений плана" id={KNM_PLAN_HISTORY_CHANGES}>
      {historyChanges && historyChanges.length > 0 && (
        <div className={styles.Items}>
          {historyChanges.map((knmHistoryItem, index) => {
            if (index > lastVisibleItemsNumber - 1) {
              return null;
            }

            return <KnmHistoryItem key={uuidv4()} data={knmHistoryItem} />;
          })}
        </div>
      )}

      {isLoadMoreButtonVisible && (
        <Button type="button" text="Показать еще" color="load" onClick={handleLoadMoreButtonClick} />
      )}
    </Section>
  );
};

const mapStateToProps = (state: IRootState): IKnmHistoryStoreProps => ({
  planId: getKnmDataPlanId(state),
  historyChanges: getPlanHistoryChanges(state),
});

export const ErknmPlanHistoryChanges = connect(mapStateToProps)(ErknmPlanHistoryChangesWithoutStore);
